import { ErrorOutlineOutlined } from '@mui/icons-material'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline'
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline'
import WatchLaterOutlined from '@mui/icons-material/WatchLaterOutlined'
import { Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CountBadge } from '@omnea-app/omui/CountBadge'
import type { SupplierStep } from '../useGetSupplierSteps'

type RequestStepStatusChipProps = {
  status: SupplierStep['status']
  amendments?: number
  tasks: SupplierStep['tasks']
  stepType: SupplierStep['stepType']
}

export const RequestStepStatusChip: React.FC<RequestStepStatusChipProps> = ({ status, amendments, tasks, stepType }) => {
  const { t } = useTranslation('supplier-dashboard', { keyPrefix: 'tasks-table.step-status' })

  if (amendments) {
    return (
      <Chip
        label={t('amendment-required')}
        color="warning"
        size="small"
        icon={<CountBadge count={amendments} color="warning" />}
      />
    )
  }

  if (stepType === 'RFX' && tasks.every((task) => task.completedOn)) {
    return <Chip label={t('completed')} color="success" size="small" icon={<CheckCircleOutline />} />
  }

  if (stepType === 'RFX' && tasks.every((task) => task.completedOn || task.submissionsClosedAt)) {
    return <Chip label={t('submissions-closed')} color="neutral" size="small" icon={<ErrorOutlineOutlined />} />
  }

  switch (status) {
    case 'COMPLETE':
      return <Chip label={t('completed')} color="success" size="small" icon={<CheckCircleOutline />} />

    case 'PENDING':
      return <Chip label={t('not-started')} color="neutral" size="small" icon={<PauseCircleOutline />} />

    default:
      return <Chip label={t('action-needed')} color="warning" size="small" icon={<WatchLaterOutlined />} />
  }
}
